<template>
  <div>
    <v-col v-if="!tieneDatosGrafica" cols="12">
      <v-alert color="blue-grey" text class="mb-0">
        <div class="text-center" style="font-size: 16px">No hay datos para mostrar</div>
      </v-alert>
    </v-col>

    <v-col v-else cols="12">
      <v-col cols="12">
        <v-row v-if="showSideKpis" dense>
          <v-col cols="3">
            <v-card outlined class="pa-4 fill-height d-flex flex-column">
              <div class="d-flex align-center mb-3">
                <span class="text-uppercase caption grey--text text--darken-1 font-weight-medium mb-4">PIEZAS
                  ESPERADAS</span>
                <v-spacer />
              </div>
              <v-row no-gutters class="flex-grow-1" justify="center" align="center">
                <template v-if="!loading">
                  <template v-if="ladosEsperadas.length">
                    <v-col v-for="(lado, idx) in ladosEsperadas" :key="'esp-' + idx"
                      :cols="colLado(ladosEsperadas, idx)" :offset="offLado(ladosEsperadas, idx)"
                      class="d-flex justify-center px-0">
                      <div class="d-flex flex-column align-center" :class="{ 'grupo-filtro-inactivo': !isGrupoActivo(lado.id) }">
                        <div class="d-flex align-center justify-center mb-1">
                          <div class="kpi-icon mr-2 kpi-icon-filter"
                            :style="{ background: coloresClaros[idx % coloresClaros.length] }"
                            @click.stop="toggleFiltroGrupo(lado.id)"
                            title="Filtrar serie por grupo">
                            <v-icon size="20" :color="paletteBars[idx % paletteBars.length]">mdi-target-variant</v-icon>
                          </div>
                          <div class="kpi-number" :style="{ color: paletteBars[idx % paletteBars.length] }">
                            {{ Math.round(lado.valor) }}
                          </div>
                        </div>
                        <div class="kpi-sub text-center mt-3" style="line-height: 15px;">{{ lado.cavidad || '' }}</div>
                      </div>
                    </v-col>
                  </template>
                  <v-col v-else class="d-flex justify-center align-center text-subtitle-2">Sin Datos</v-col>
                </template>

                <v-col v-else cols="12" class="d-flex justify-center align-center">
                  <v-progress-circular indeterminate :color="paletteBars[0]" />
                </v-col>
              </v-row>
            </v-card>
          </v-col>

          <v-col cols="3">
            <v-card outlined class="pa-4 fill-height d-flex flex-column">
              <div class="d-flex align-center mb-3">
                <span class="text-uppercase caption grey--text text--darken-1 font-weight-medium mb-4">PIEZAS OK</span>
                <v-spacer />
              </div>
              <v-row no-gutters class="flex-grow-1" justify="center" align="center">
                <template v-if="!loading">
                  <template v-if="lados.length">
                    <v-col v-for="(lado, idx) in lados" :key="'ok-' + idx" :cols="colLado(lados, idx)"
                      :offset="offLado(lados, idx)" class="d-flex justify-center px-0">
                      <div class="d-flex flex-column align-center" :class="{ 'grupo-filtro-inactivo': !isGrupoActivo(lado.id) }">
                        <div class="d-flex align-center justify-center mb-1">
                          <div class="kpi-icon mr-2 kpi-icon-filter"
                            :style="{ background: coloresClaros[idx % coloresClaros.length] }"
                            @click.stop="toggleFiltroGrupo(lado.id)"
                            title="Filtrar serie por grupo">
                            <v-icon size="20" :color="paletteBars[idx % paletteBars.length]">mdi-trending-up</v-icon>
                          </div>
                          <div class="kpi-number" :style="{ color: paletteBars[idx % paletteBars.length] }">
                            {{ Math.round(lado.valor) }}
                          </div>
                        </div>
                        <div class="kpi-sub text-center mt-3" style="line-height: 15px;">{{ lado.cavidad || '' }}</div>
                      </div>
                    </v-col>
                  </template>
                  <v-col v-else class="d-flex justify-center align-center text-subtitle-2">Sin Datos</v-col>
                </template>

                <v-col v-else cols="12" class="d-flex justify-center align-center">
                  <v-progress-circular indeterminate :color="paletteBars[0]" />
                </v-col>
              </v-row>
            </v-card>
          </v-col>

          <v-col cols="3">
            <v-card outlined class="pa-4 fill-height d-flex flex-column">
              <div class="d-flex align-center mb-3">
                <span class="text-uppercase caption grey--text text--darken-1 font-weight-medium mb-4">PIEZAS NO
                  OK</span>
                <v-spacer />
              </div>
              <v-row no-gutters class="flex-grow-1" justify="center" align="center">
                <template v-if="!loading">
                  <template v-if="ladosNoOk.length">
                    <v-col v-for="(lado, idx) in ladosNoOk" :key="'nok-' + idx" :cols="colLado(ladosNoOk, idx)"
                      :offset="offLado(ladosNoOk, idx)" class="d-flex justify-center px-0">
                      <div class="d-flex flex-column align-center" :class="{ 'grupo-filtro-inactivo': !isGrupoActivo(lado.id) }">
                        <div class="d-flex align-center justify-center mb-1">
                          <div class="kpi-icon mr-2 kpi-icon-filter"
                            :style="{ background: errorBg }"
                            @click.stop="toggleFiltroGrupo(lado.id)"
                            title="Filtrar serie por grupo">
                            <v-icon size="20" :color="error">mdi-delete</v-icon>
                          </div>
                          <div class="d-flex align-end">
                            <div class="kpi-number error--text">{{ Math.round(lado.valor) }}</div>
                            <div v-if="lado.okBruto != null" class="kpi-suffix grey--text text--darken-1">/ {{
                              Math.round(lado.okBruto) }}</div>
                          </div>
                        </div>
                        <div class="kpi-sub text-center mt-3" style="line-height: 15px;">{{ lado.cavidad || '' }}</div>
                      </div>
                    </v-col>
                  </template>
                  <v-col v-else class="d-flex justify-center align-center text-subtitle-2">Sin Datos</v-col>
                </template>

                <v-col v-else cols="12" class="d-flex justify-center align-center">
                  <v-progress-circular indeterminate :color="paletteBars[0]" />
                </v-col>
              </v-row>
            </v-card>
          </v-col>

          <v-col cols="3">
            <v-card outlined class="pa-4 fill-height d-flex flex-column">
              <div class="d-flex align-center mb-3">
                <span class="text-uppercase caption grey--text text--darken-1 font-weight-medium mb-4">DIFERENCIA</span>
                <v-spacer />
              </div>
              <v-row no-gutters class="flex-grow-1" justify="center" align="center">
                <template v-if="!loading">
                  <template v-if="ladosDelta.length">
                    <v-col v-for="(lado, idx) in ladosDelta" :key="'delta-' + idx" :cols="colLado(ladosDelta, idx)"
                      :offset="offLado(ladosDelta, idx)" class="d-flex justify-center px-0">
                      <div class="d-flex flex-column align-center" :class="{ 'grupo-filtro-inactivo': !isGrupoActivo(lado.id) }">
                        <div class="d-flex align-center justify-center mb-1">
                          <div class="kpi-icon mr-2 kpi-icon-filter"
                            :style="{ background: lado.valor >= 0 ? successBg : errorBg }"
                            @click.stop="toggleFiltroGrupo(lado.id)"
                            title="Filtrar serie por grupo">
                            <v-icon size="20" :color="lado.valor >= 0 ? success : error">mdi-sigma-lower</v-icon>
                          </div>
                          <div class="kpi-number" :style="{ color: lado.valor >= 0 ? success : error }"
                            :class="lado.valor < 0 ? 'error--text' : ''">
                            {{ Math.round(Number(lado.valor)) }}
                          </div>
                        </div>
                        <div class="kpi-sub text-center mt-3" style="line-height: 15px;">{{ lado.cavidad || '' }}</div>
                      </div>
                    </v-col>
                  </template>
                  <v-col v-else class="d-flex justify-center align-center text-subtitle-2">Sin Datos</v-col>
                </template>

                <v-col v-else cols="12" class="d-flex justify-center align-center">
                  <v-progress-circular indeterminate :color="paletteBars[0]" />
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12">
        <v-row>
          <v-col :cols="12" :md="showSideKpis ? 8 : 12" :lg="showSideKpis ? 8 : 12" :xl="showSideKpis ? 8 : 12">
            <div v-if="filtroGrupoNombre" class="caption mb-1 grey--text text--darken-1">
              Filtro por grupo: <strong>{{ filtroGrupoNombre }}</strong> (click de nuevo para limpiar)
            </div>
            <v-row v-if="configGrafica.mostrarKPIsGrafica" class="pb-2">
              <v-col v-for="card in metricCards" :key="card.key" cols="4">
                <v-card class="chart-metric-card" :class="[
                  card.activo ? 'chart-metric-card--active' : 'chart-metric-card--inactive'
                ]" :style="card.activo ? { backgroundColor: card.color } : {}" @click="toggleChartMetric(card.key)">
                  <v-card-text class="d-flex align-center py-3">
                    <v-icon size="20" class="mr-2"
                      :color="card.activo ? card.iconColor : '#78909C'">{{ card.icon }}</v-icon>
                    <span class="font-weight-medium">{{ card.label }}</span>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <apexchart :key="chartKey" type="line" height="500" :options="horaHoraOpts" :series="horaHoraSeries" />
          </v-col>

          <v-col v-if="showSideKpis" cols="4" md="4" lg="4" xl="4">
            <v-row>
              <!-- TC Esperado -->
              <v-col cols="6">
                <v-card class="pa-4" elevation="1">
                  <div class="d-flex align-center mb-3">
                    <v-avatar :color="secondPalette[4]" size="36" class="mr-3">
                      <v-icon color="white">mdi-clock-outline</v-icon>
                    </v-avatar>
                    <div>
                      <div class="font-weight-bold" :style="{ fontSize: '15px !important' }">TC Esperado</div>
                      <div class="text--secondary" :style="{ fontSize: '13px !important' }">
                        {{ tcProgramadoTxt }}
                      </div>
                    </div>
                  </div>
                </v-card>
              </v-col>

              <!-- TC Real -->
              <v-col cols="6">
                <v-card class="pa-4" elevation="1" style="cursor:pointer" @click="abrirHistoricoTC()">
                  <div class="d-flex align-center mb-3">
                    <v-avatar :color="secondPalette[5]" size="36" class="mr-3">
                      <v-icon color="white">mdi-timer-outline</v-icon>
                    </v-avatar>
                    <div>
                      <div class="font-weight-bold" :style="{ fontSize: '15px !important' }">TC Real</div>
                      <div class="text--secondary" :style="{ fontSize: '13px !important' }">
                        {{ tcRealTxt }}
                      </div>
                    </div>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="6">
                <v-card class="pa-4" elevation="1">
                  <div class="d-flex align-center mb-3">
                    <v-avatar :color="secondPalette[0]" size="36" class="mr-3">
                      <v-icon color="white">mdi-chart-bar-stacked</v-icon>
                    </v-avatar>
                    <div>
                      <div class="font-weight-bold" :style="{ fontSize: '15px !important' }">{{ tituloOee }}</div>
                      <div class="text--secondary" :style="{ fontSize: '13px !important' }">
                        {{ sinDatosOEE ? 'Sin Datos' : pf(kpisActuales.oee) }}
                      </div>
                    </div>
                  </div>
                </v-card>
              </v-col>

              <v-col cols="6">
                <v-card class="pa-4 clickable-card" elevation="1" @click="abrirDialogoParos()">
                  <div class="d-flex align-center mb-3">
                    <v-avatar :color="secondPalette[1]" size="36" class="mr-3">
                      <v-icon color="white">mdi-clock-outline</v-icon>
                    </v-avatar>
                    <div>
                      <div class="font-weight-bold" :style="{ fontSize: '15px !important' }">{{ tituloDisponibilidad }}</div>
                      <div class="text--secondary" :style="{ fontSize: '13px !important' }">
                        {{ sinDatosOEE ? 'Sin Datos' : pf(kpisActuales.disp) }}
                      </div>
                    </div>
                  </div>
                </v-card>
              </v-col>

              <v-col cols="6">
                <v-card class="pa-4" elevation="1">
                  <div class="d-flex align-center mb-3">
                    <v-avatar :color="secondPalette[2]" size="36" class="mr-3">
                      <v-icon color="white">mdi-run</v-icon>
                    </v-avatar>
                    <div>
                      <div class="font-weight-bold" :style="{ fontSize: '15px !important' }">{{ tituloEficiencia }}</div>
                      <div class="text--secondary" :style="{ fontSize: '13px !important' }">
                        {{ sinDatosOEE ? 'Sin Datos' : pf(kpisActuales.rend) }}
                      </div>
                    </div>
                  </div>
                </v-card>
              </v-col>

              <v-col cols="6">
                <v-card class="pa-4 clickable-card" elevation="1" @click="abrirDialogoNoOk()">
                  <div class="d-flex align-center mb-3">
                    <v-avatar :color="secondPalette[3]" size="36" class="mr-3">
                      <v-icon color="white">mdi-star-circle-outline</v-icon>
                    </v-avatar>
                    <div>
                      <div class="font-weight-bold" :style="{ fontSize: '15px !important' }">{{ tituloCalidad }}</div>
                      <div class="text--secondary" :style="{ fontSize: '13px !important' }">
                        {{ sinDatosOEE ? 'Sin Datos' : pf(kpisActuales.cali) }}
                      </div>
                    </div>
                  </div>
                </v-card>
              </v-col>

              <v-col cols="12">
                <v-card class="pa-4" elevation="1" style="border-radius:12px;">
                  <div class="d-flex align-center mb-2">
                    <div class="mr-3"
                      style="width:36px;height:36px;border-radius:50%;background:#C82A54;color:white;display:flex;align-items:center;justify-content:center;">
                      <v-icon small color="white">mdi-chart-bar</v-icon>
                    </div>
                    <div>
                      <div class="text-subtitle-2">Tiempo de paro programado</div>
                      <div>{{ sinDatosOEE ? 'Sin Datos' : `${t(kpisActuales.segParoProg).h} : ${t(kpisActuales.segParoProg).m} : ${t(kpisActuales.segParoProg).s}` }}</div>
                    </div>
                  </div>
                </v-card>
              </v-col>

              <v-col cols="12">
                <v-card class="pa-4" elevation="1" style="border-radius:12px;">
                  <div class="d-flex align-center mb-2">
                    <div class="mr-3"
                      style="width:36px;height:36px;border-radius:50%;background:#C82A54;color:white;display:flex;align-items:center;justify-content:center;">
                      <v-icon small color="white">mdi-timer-outline</v-icon>
                    </div>
                    <div>
                      <div class="text-subtitle-2">Tiempo de paro no programado</div>
                      <div>{{ sinDatosOEE ? 'Sin Datos' : `${t(kpisActuales.segParoNP).h} : ${t(kpisActuales.segParoNP).m} : ${t(kpisActuales.segParoNP).s}` }}</div>
                    </div>
                  </div>
                </v-card>
              </v-col>

              <v-col v-if="false" cols="12">
                <v-card class="pa-4" elevation="1" style="border-radius:12px;">
                  <div class="d-flex align-center mb-2">
                    <div class="mr-3"
                      style="width:36px;height:36px;border-radius:50%;background:#C82A54;color:white;display:flex;align-items:center;justify-content:center;">
                      <v-icon small color="white">mdi-timer-outline</v-icon>
                    </div>
                    <div>
                      <div class="text-subtitle-2">Tiempo Muerto</div>
                      <div>{{ sinDatosOEE ? 'Sin Datos' : `${t(kpisActuales.tiempoMuertoSeg).h} : ${t(kpisActuales.tiempoMuertoSeg).m} : ${t(kpisActuales.tiempoMuertoSeg).s}` }}</div>
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row v-if="mostrarTablaODT" class="mt-4">
          <v-col cols="12">
            <v-data-table
              :headers="headersOperacionesODT"
              :items="operacionesOdt"
              dense
              disable-pagination
              hide-default-footer
            >
              <template v-slot:item.tiempoMinXUnidad="{ item }">
                {{ item.tiempoMinXUnidad }}
              </template>
              <template v-slot:item.oee="{ item }">
                {{ item.oeeTexto }}
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-col>

    </v-col>
    <HistoricoTCGrafica v-model="dialogHistoricoTC" :idMaquinaIns="histTc_idMaquinaIns" :fecha="histTc_fecha"
      :turno="histTc_turno" :maquinaNombre="histTc_maquinaNombre" :tcProgramado="histTc_tcProgramado"
      :tcRealMediana.sync="tcRealMedianaSeg" />
  </div>
</template>

<script>
import HistoricoTCGrafica from '../ReportesOEE/HistoricoTCGrafica.vue';

export default {
  components: {
    HistoricoTCGrafica
  },
  props: {
    value: { type: Object, required: true },
    showSideKpis: { type: Boolean, default: true },
    loading: { type: Boolean, default: false },
    tiempoMuerto: { type: Boolean, default: false },
    modoGrupo: { type: String, default: 'Cavidades' },
    mostrarEsperadasCrudas: { type: Boolean, default: true },
    mostrarTablaODT: { type: Boolean, default: false },
    configReporte: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      paletteBars: ['#1E88E5', '#FB8C00', '#26A69A', '#8E24AA', '#EF5350', '#5E35B1'],
      secondPalette: ['#3949AB', '#F4511E', '#00796B', '#7CB342', '#D81B60', '#00ACC1'],
      coloresClaros: ['#E3F2FD', '#FFF3E0'],
      error: '#EF5350',
      errorBg: '#FDECEC',
      success: '#26A69A',
      successBg: '#E8F5E9',

      dialogHistoricoTC: false,
      tcRealMedianaSeg: 0,
      filtroGrupoId: null,
    }
  },
  computed: {
    response() { return this.value || {} },
    configGrafica() {
      const cfg = this.configReporte || {}
      return {
        mostrarKPIsGrafica: cfg.mostrarKPIsGrafica !== false,
        mostrarHechas: cfg.mostrarHechas !== false,
        mostrarEsperadas: cfg.mostrarEsperadas !== false,
        mostrarRate: cfg.mostrarRate !== false,
      }
    },
    mostrarHechasActivas() { return this.configGrafica.mostrarHechas },
    mostrarEsperadasActivas() { return this.configGrafica.mostrarEsperadas },
    mostrarRateActivas() {
      if (!this.mostrarEsperadasCrudas) return false
      return this.configGrafica.mostrarRate
    },
    metricCards() {
      return [
        {
          key: 'mostrarHechas',
          label: 'Mostrar piezas hechas',
          icon: 'mdi-chart-bar',
          color: '#BBDEFB',
          iconColor: '#1E88E5',
          activo: this.mostrarHechasActivas,
        },
        {
          key: 'mostrarEsperadas',
          label: 'Mostrar piezas esperadas',
          icon: 'mdi-chart-line',
          color: '#C8E6C9',
          iconColor: '#26A69A',
          activo: this.mostrarEsperadasActivas,
        },
        {
          key: 'mostrarRate',
          label: 'Mostrar piezas rate',
          icon: 'mdi-speedometer',
          color: '#FFE0B2',
          iconColor: '#FB8C00',
          activo: this.mostrarRateActivas,
        },
      ]
    },
    sinDatosOEE() {
      if (this.filtroGrupoId) {
        const g = this.factoresPorGrupo?.[this.filtroGrupoId]
        const hasFactor = [g?.oee, g?.disp, g?.rend, g?.cali].some(v => Number.isFinite(Number(v)))
        if (hasFactor) return false
      }
      return this.response?.resultadosOEE?.aplicaOEE === false
    },
    rows() {
      const a = this.response?.datosHoraViewModel || this.response?.DatosHoraViewModel || []
      return Array.isArray(a) ? a.slice().sort((x, y) => String(x?.inicio || '').localeCompare(String(y?.inicio || ''))) : []
    },
    tieneDatosGrafica() { return this.rows.length > 0 },
    isArticulos() { return String(this.modoGrupo || '').toLowerCase() === 'articulos' },

    metaByOp() {
      const det = this.response?.detallesODTOperaciones || this.response?.DetallesODTOperaciones || []
      const m = {}
        ; (Array.isArray(det) ? det : []).forEach(d => {
          const idOp = d?.idOperacion ?? d?.IdOperacion
          if (idOp == null) return
          m[idOp] = {
            idOp,
            idArticulo: d?.idArticulo ?? d?.IdArticulo,
            nombreArticulo: d?.nombreArticulo ?? d?.NombreArticulo,
            nombreToken: d?.nombreToken ?? d?.NombreToken,
            clave: d?.clave ?? d?.Clave,
            oee: this.n(d?.oee ?? d?.Oee),
            pesoOee: this.n(d?.piezasHechas ?? d?.PiezasHechas ?? d?.piezasEsperadas ?? d?.PiezasEsperadas),
            disponibilidad: this.n(d?.disponibilidad ?? d?.Disponibilidad),
            eficiencia: this.n(d?.eficiencia ?? d?.Eficiencia),
            calidad: this.n(d?.calidad ?? d?.Calidad),
          }
        })
      return m
    },
    opIdsEnRows() {
      const s = {}
      this.rows.forEach(h => (h?.operaciones || []).forEach(op => {
        const id = op?.idOperacion ?? op?.IdOperacion
        if (id != null) s[id] = true
      }))
      return Object.keys(s).map(Number).sort((a, b) => a - b)
    },
    grupos() {
      const ids = this.opIdsEnRows
      if (!ids.length) return [{ id: '__default__', name: 'Única', opIds: ['__default__'] }]

      if (!this.isArticulos) {
        return ids.map(id => {
          const meta = this.metaByOp[id] || {}
          const name = meta.nombreToken || meta.clave || meta.nombreArticulo || ('Op ' + id)
          return { id, name, opIds: [id] }
        })
      }

      const map = {}
      ids.forEach(id => {
        const meta = this.metaByOp[id] || {}
        const key = meta.idArticulo != null ? `A:${meta.idArticulo}` : (meta.nombreArticulo ? `AN:${meta.nombreArticulo}` : `O:${id}`)
        const name = meta.nombreArticulo || meta.nombreToken || meta.clave || ('Op ' + id)
        map[key] = map[key] || { id: key, name, opIds: [] }
        map[key].opIds.push(id)
      })
      return Object.values(map).sort((a, b) => String(a.name).localeCompare(String(b.name)))
    },

    grpAgg() {
      const acc = {}
      this.grupos.forEach(g => (acc[g.id] = { esp: 0, ok: 0, noOk: 0 }))
      this.rows.forEach(h => {
        const byId = {}
          ; (h?.operaciones || []).forEach(op => {
            const id = op?.idOperacion ?? op?.IdOperacion
            if (id != null) byId[id] = op
          })
        this.grupos.forEach(g => {
          let esp = 0, ok = 0, noOk = 0
            ; (g.opIds || []).forEach(idOp => {
              const op = byId[idOp] || {}
              esp += this.n(op?.piezasEsperadasReales ?? op?.piezasEsperadas ?? 0)
              ok += this.n(op?.piezasOk ?? 0)
              noOk += this.n(op?.piezasNoOk ?? 0)
            })
          acc[g.id].esp += esp
          acc[g.id].ok += ok
          acc[g.id].noOk += noOk
        })
      })
      return acc
    },
    ladosEsperadas() { return this.grupos.map(g => ({ id: g.id, valor: this.grpAgg[g.id]?.esp || 0, cavidad: g.name })) },
    lados() { return this.grupos.map(g => ({ id: g.id, valor: this.grpAgg[g.id]?.ok || 0, cavidad: g.name })) },
    ladosNoOk() {
      return this.grupos.map(g => {
        const ok = this.grpAgg[g.id]?.ok || 0
        const no = this.grpAgg[g.id]?.noOk || 0
        return { id: g.id, valor: no, okBruto: ok + no, cavidad: g.name }
      })
    },
    ladosDelta() {
      return this.grupos.map(g => {
        const esp = this.grpAgg[g.id]?.esp || 0
        const ok = this.grpAgg[g.id]?.ok || 0
        const no = this.grpAgg[g.id]?.noOk || 0
        return { id: g.id, valor: (ok + no) - esp, cavidad: g.name }
      })
    },
    factoresPorGrupo() {
      const out = {}

      this.grupos.forEach((g) => {
        const initAgg = () => ({ sumW: 0, sumVW: 0, sumSimple: 0, cntSimple: 0 })
        const agg = {
          oee: initAgg(),
          disp: initAgg(),
          rend: initAgg(),
          cali: initAgg(),
        }
        const acum = (bucket, value, peso) => {
          if (!Number.isFinite(value)) return
          if (peso > 0) {
            bucket.sumVW += value * peso
            bucket.sumW += peso
          } else {
            bucket.sumSimple += value
            bucket.cntSimple += 1
          }
        }
        const final = (bucket) => {
          if (bucket.sumW > 0) return bucket.sumVW / bucket.sumW
          if (bucket.cntSimple > 0) return bucket.sumSimple / bucket.cntSimple
          return null
        }

        ; (g.opIds || []).forEach((idOp) => {
          const meta = this.metaByOp[idOp]
          if (!meta) return

          const peso = this.n(meta.pesoOee)
          acum(agg.oee, Number(meta.oee), peso)
          acum(agg.disp, Number(meta.disponibilidad), peso)
          acum(agg.rend, Number(meta.eficiencia), peso)
          acum(agg.cali, Number(meta.calidad), peso)
        })

        out[g.id] = {
          oee: final(agg.oee),
          disp: final(agg.disp),
          rend: final(agg.rend),
          cali: final(agg.cali),
        }
      })

      return out
    },
    gruposActivos() {
      const all = Array.isArray(this.grupos) ? this.grupos : []
      if (!this.filtroGrupoId) return all
      return all.filter(g => g.id === this.filtroGrupoId)
    },
    filtroGrupoNombre() {
      const match = (this.grupos || []).find(g => g.id === this.filtroGrupoId)
      return match?.name || ''
    },
    factorSufijoTitulo() {
      return this.filtroGrupoNombre ? `de ${this.filtroGrupoNombre}` : 'promedio'
    },
    tituloOee() {
      return `OEE ${this.factorSufijoTitulo}`
    },
    tituloDisponibilidad() {
      return `Disponibilidad ${this.factorSufijoTitulo}`
    },
    tituloEficiencia() {
      return `Eficiencia ${this.factorSufijoTitulo}`
    },
    tituloCalidad() {
      return `Calidad ${this.factorSufijoTitulo}`
    },
    factoresPromedio() {
      const base = Object.values(this.factoresPorGrupo || {})
      const avg = (key) => {
        const vals = base.map(x => Number(x?.[key])).filter(v => Number.isFinite(v))
        if (!vals.length) return null
        return vals.reduce((a, b) => a + b, 0) / vals.length
      }
      return {
        oee: avg('oee'),
        disp: avg('disp'),
        rend: avg('rend'),
        cali: avg('cali'),
      }
    },
    // ===== CHART =====
    categoriasX() { return this.rows.map(h => `${this.hh(h?.inicio)} - ${this.hh(h?.fin)}`) },

    seriesHechasPorGrupo() {
      return this.gruposActivos.map((g, i) => ({
        name: `${g.name} Hechas`,
        type: 'column',
        data: this.rows.map(h => this.sumGrupo(h, g, 'hechas')),
        color: this.paletteBars[i % this.paletteBars.length],
      }))
    },
    seriesEsperadasPorGrupo() {
      return this.gruposActivos.map((g, i) => ({
        name: `${g.name} Esperadas`,
        type: 'line',
        data: this.rows.map(h => this.sumGrupo(h, g, 'esperadas')),
        color: this.secondPalette[i % this.secondPalette.length],
      }))
    },
    seriesCrudasPorGrupo() {
      return this.gruposActivos.map((g, i) => ({
        name: `${g.name} Esperadas rate`,
        type: 'line',
        data: this.rows.map(h => this.sumGrupo(h, g, 'crudas')),
        color: this.paletteBars[(i + 1) % this.paletteBars.length],
      }))
    },

    horaHoraSeries() {
      const s = []
      if (this.mostrarHechasActivas) s.push(...this.seriesHechasPorGrupo)
      if (this.mostrarEsperadasActivas) s.push(...this.seriesEsperadasPorGrupo)
      if (this.mostrarRateActivas) s.push(...this.seriesCrudasPorGrupo)
      return s
    },

    // ✅ aquí: además de columnas, activamos dataLabels SOLO para "Esperadas" (reales)
    labelSeriesIdxs() {
      const out = []
      this.horaHoraSeries.forEach((x, i) => {
        if (x.type === 'column') out.push(i)
        else if (
          String(x.name || '').includes(' Esperadas')
          && !String(x.name || '').includes('crudas')
          && !String(x.name || '').includes('rate')
        ) out.push(i)
      })
      return out
    },

    strokeWidths() { return this.horaHoraSeries.map(x => (x.type === 'column' ? 0 : 3)) },
    markerSizes() { return this.horaHoraSeries.map(x => (x.type === 'column' ? 0 : 4)) },

    horaHoraOpts() {
      // const fmt = (v) => Math.round(Number(v || 0))
      const fmt = (v) => Math.round(Number((v ?? 0).toFixed(0)))
      return {
        chart: { type: 'line', stacked: false, toolbar: { show: false }, animations: { enabled: true } },
        xaxis: { categories: this.categoriasX, tickPlacement: 'between', labels: { rotate: -35, rotateAlways: true, trim: false, style: { fontSize: '11px' }, offsetY: 6 } },
        legend: { show: true, position: 'top' },
        plotOptions: { bar: { columnWidth: '40%', borderRadius: 4 } },
        stroke: { width: this.strokeWidths, curve: 'smooth' },
        markers: { size: this.markerSizes, strokeWidth: 2, strokeColors: '#fff' },

        // "tarjetita" (background) para los labels (se verán en columnas y en Esperadas reales)
        dataLabels: {
          enabled: true,
          enabledOnSeries: this.labelSeriesIdxs,
          formatter: (v) => fmt(v),
          offsetY: -2,
          style: { fontSize: '11px' },
          background: {
            enabled: true,
            borderRadius: 6,
            padding: 4,
            opacity: 0.92,
            borderWidth: 1,
          },
        },

        tooltip: { shared: true, intersect: false, y: { formatter: (v) => fmt(v) } },
        yaxis: { min: 0, forceNiceScale: true, title: { text: 'Piezas' } },
      }
    },

    chartKey() {
      return (this.categoriasX || []).join('|')
        + '|' + (this.grupos || []).map(g => g.id).join(',')
        + '|' + String(this.filtroGrupoId || '')
        + '|' + (this.mostrarRateActivas ? '1' : '0')
        + '|' + (this.mostrarHechasActivas ? '1' : '0')
        + '|' + (this.mostrarEsperadasActivas ? '1' : '0')
        + '|' + String(this.modoGrupo || '')
    },
    operacionesOdt() {
      const raw = this.response?.detallesODTOperaciones || this.response?.DetallesODTOperaciones || [];
      const arr = Array.isArray(raw) ? raw : [];

      return arr.map((d, idx) => {
        const clave = d?.clave ?? d?.Clave ?? '';
        const tiempo = d?.tiempoMinXUnidad ?? d?.TiempoMinXUnidad ?? 0;
        const nombreArticulo = d?.nombreArticulo ?? d?.NombreArticulo ?? '';
        const nombreToken = d?.nombreToken ?? d?.NombreToken ?? '';
        const nombreInstanciaMaquina = d?.nombreInstanciaMaquina ?? d?.NombreInstanciaMaquina ?? '';
        const oee = Number(d?.oee ?? d?.Oee);

        return {
          id: d?.idOperacion ?? d?.IdOperacion ?? idx,
          clave,
          tiempoMinXUnidad: Number.isFinite(Number(tiempo)) ? Number(tiempo) : tiempo,
          nombreArticulo,
          nombreToken,
          nombreInstanciaMaquina,
          oee,
          oeeTexto: Number.isFinite(oee) ? this.pf(oee) : 'Sin Datos',
        };
      });
    },
    headersOperacionesODT() {
      return [
        { text: 'Clave ODT', value: 'clave' },
        { text: 'Artículo', value: 'nombreArticulo' },
        { text: 'TC Esperado', value: 'tiempoMinXUnidad' },
        { text: 'OEE', value: 'oee' },
        { text: 'Máquina', value: 'nombreInstanciaMaquina' },
        { text: 'Token', value: 'nombreToken' },
      ];
    },

    kpisActuales() {
      const r = this.response || {}
      const ro = r?.resultadosOEE || {}
      const factoresSeleccionados = this.filtroGrupoId
        ? (this.factoresPorGrupo?.[this.filtroGrupoId] || {})
        : (this.factoresPromedio || {})
      const muerto = this.n(r?.totalSegundosMuertos ?? 0)
      return {
        oee: factoresSeleccionados?.oee != null ? this.n(factoresSeleccionados.oee) : this.n(ro?.oee),
        disp: factoresSeleccionados?.disp != null ? this.n(factoresSeleccionados.disp) : this.n(ro?.disponibilidad),
        rend: factoresSeleccionados?.rend != null ? this.n(factoresSeleccionados.rend) : this.n(ro?.eficiencia),
        cali: factoresSeleccionados?.cali != null ? this.n(factoresSeleccionados.cali) : this.n(ro?.calidad),
        segParoProg: this.n(r?.segundosParoProgramado),
        segParoNP: this.n(r?.segundosParoNoProgramado),
        tiempoMuertoSeg: muerto,
      }
    },
    tcProgramadoSegPza() {
      const rows = Array.isArray(this.rows) ? this.rows : []
      const ops = []
      rows.forEach(h => (h?.operaciones || []).forEach(op => ops.push(op)))
      if (!ops.length) return 0

      const getTc = (op) => {
        const cand = [
          op?.tiempoMinXUnidad,
          op?.tiempo_ciclo,
          op?.tiempoCiclo,
          op?.cycle_time,
          op?.tc,
        ]
        for (const v of cand) {
          const n = Number(v)
          if (Number.isFinite(n) && n > 0) return n
        }
        return null
      }

      const vals = ops.map(getTc).filter(v => v != null)
      if (!vals.length) return 0

      // pondera por piezas (si existe), si no, promedio simple
      const pesos = ops.map(op =>
        this.n(op?.piezasEsperadasReales ?? op?.piezasEsperadas ?? (this.n(op?.piezasOk) + this.n(op?.piezasNoOk)) ?? 0)
      )
      const tienePesos = pesos.some(w => w > 0)

      if (tienePesos) {
        let sumVW = 0, sumW = 0
        for (let i = 0; i < vals.length; i++) {
          const w = pesos[i] || 0
          sumVW += vals[i] * w
          sumW += w
        }
        if (sumW > 0) return sumVW / sumW
      }

      return vals.reduce((a, b) => a + b, 0) / vals.length
    },

    tcProgramadoTxt() {
      const s = Number(this.tcProgramadoSegPza)
      if (!Number.isFinite(s) || s <= 0) return '—'
      return `${s.toFixed(1)} seg/pza`
    },
    histTc_idMaquinaIns() {
      return Number(this.response?.idMaquinaIns || 0)
    },
    histTc_maquinaNombre() {
      return String(this.response?.instanciaNombre || this.response?.instanciaModelo || '')
    },
    histTc_fecha() {
      const ini = String(this.rows?.[0]?.inicio || '')
      return ini.length >= 10 ? ini.slice(0, 10) : ''   // "YYYY-MM-DD"
    },
    histTc_turno() {
      const ini = this.rows?.[0]?.inicio
      const fin = this.rows?.[this.rows.length - 1]?.fin
      return { inicio: this.hh(ini), fin: this.hh(fin) } // "HH:mm"
    },
    histTc_tcProgramado() {
      // usa tu computed actual si ya lo tienes; si no, cae al JSON de detallesODTOperaciones
      const a = Number(this.tcProgramadoSegPza || 0)
      if (a > 0) return a
      const det = (this.response?.detallesODTOperaciones || [])[0]
      return Number(det?.tiempoMinXUnidad || 0)
    },
    tcRealSegPza() {
      // si algún día el backend manda tcReal, úsalo
      const tcBack = this.n(this.response?.tcReal?.segundos ?? 0)
      if (tcBack > 0) return tcBack

      let sumS = 0
      let sumP = 0

      this.rows.forEach(h => (h?.operaciones || []).forEach(op => {
        const p = this.n(op?.piezasOk) + this.n(op?.piezasNoOk)
        const s = this.n(op?.segundosActivos ?? op?.segundosConOperacion ?? 0)
        sumS += s
        sumP += p
      }))

      return sumP > 0 ? (sumS / sumP) : 0
    },

    tcRealTxt() {
      const mediana = Number(this.tcRealMedianaSeg || 0)
      return mediana > 0 ? `${mediana.toFixed(1)} seg/pza` : '—'
    }
  },
  methods: {
    n(v) { const x = Number(v); return isNaN(x) ? 0 : x },
    hh(iso) { const s = String(iso || ''); return s.length >= 16 ? s.slice(11, 16) : '' },
    pct(v) {
      const x = Number(v)
      if (!Number.isFinite(x)) return '0%'
      // return `${Math.max(0, Math.min(100, x)).toFixed(2)}%`
      return `${Math.max(0, x).toFixed(2)}%`
    },
    pf(v) { return this.pct(v) },
    t(seg) {
      const s = Math.max(0, Math.floor(this.n(seg)))
      const h = String(Math.floor(s / 3600)).padStart(2, '0')
      const m = String(Math.floor((s % 3600) / 60)).padStart(2, '0')
      const ss = String(s % 60).padStart(2, '0')
      return { h, m, s: ss }
    },
    colLado(arr) { return arr.length === 1 ? 'auto' : 6 },
    offLado(arr, idx) { return (arr.length > 1 && arr.length % 2 === 1 && idx === arr.length - 1) ? 3 : 0 },
    isGrupoActivo(idGrupo) {
      return !this.filtroGrupoId || this.filtroGrupoId === idGrupo
    },
    toggleFiltroGrupo(idGrupo) {
      this.filtroGrupoId = this.filtroGrupoId === idGrupo ? null : idGrupo
    },
    toggleChartMetric(key) {
      const actual = this.configGrafica
      const next = {
        mostrarHechas: actual.mostrarHechas,
        mostrarEsperadas: actual.mostrarEsperadas,
        mostrarRate: actual.mostrarRate,
      }
      next[key] = !next[key]
      this.$emit('update-config-reporte', next)
    },

    sumGrupo(h, g, tipo) {
      const byId = {}
        ; (h?.operaciones || []).forEach(op => {
          const id = op?.idOperacion ?? op?.IdOperacion
          if (id != null) byId[id] = op
        })

      return (g?.opIds || []).reduce((s, idOp) => {
        const op = byId[idOp] || {}
        const ok = this.n(op?.piezasOk ?? 0)
        const noOk = this.n(op?.piezasNoOk ?? 0)

        if (tipo === 'hechas') return s + ok + noOk
        if (tipo === 'crudas') return s + this.n(op?.piezasEsperadasCrudasReales ?? op?.piezasEsperadasCrudas ?? 0)
        return s + this.n(op?.piezasEsperadasReales ?? op?.piezasEsperadas ?? 0)
      }, 0)
    },
    abrirHistoricoTC() {
      const id = Number(this.histTc_idMaquinaIns || 0)
      const fecha = String(this.histTc_fecha || '')
      const turno = this.histTc_turno || {}
      const ini = String(turno.inicio || '')
      const fin = String(turno.fin || '')

      if (id <= 0) return
      if (!fecha || fecha.length < 10) return
      if (!ini || ini.length < 4) return
      if (!fin || fin.length < 4) return

      this.dialogHistoricoTC = true
    },
    abrirDialogoParos() {
      this.$emit('ver-paros');
    },
    abrirDialogoNoOk() {
      this.$emit('ver-no-ok');
    },
  },
  watch: {
    grupos: {
      immediate: true,
      deep: false,
      handler(next) {
        if (!this.filtroGrupoId) return
        const existe = (Array.isArray(next) ? next : []).some(g => g.id === this.filtroGrupoId)
        if (!existe) this.filtroGrupoId = null
      }
    }
  },
}
</script>

<style scoped>
.kpi-number {
  font-size: 34px;
  line-height: 1;
  font-weight: 800;
}

.kpi-sub {
  font-size: 11px;
  letter-spacing: .4px;
  color: #78909C;
}

.kpi-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.kpi-icon-filter {
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}
.kpi-icon-filter:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}
.grupo-filtro-inactivo {
  opacity: 0.45;
}

.clickable-card {
  cursor: pointer;
  transition: all 0.2s ease;
}

.clickable-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

.chart-metric-card {
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid #CFD8DC;
}

.chart-metric-card:hover {
  transform: translateY(-1px);
}

.chart-metric-card--active {
  border-color: rgba(0, 0, 0, 0.08);
}

.chart-metric-card--inactive {
  background: #ECEFF1;
  color: #90A4AE;
}
</style>
